module.exports = __webpack_public_path__ + "img/section3_img.2753c601.png";